var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLayer9(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.52699 2.29773L1.23087 14.0142C1.08044 14.2648 1.00085 14.5489 1.00001 14.8383C0.999164 15.1276 1.0771 15.4121 1.22607 15.6635C1.37504 15.9149 1.58984 16.1244 1.84911 16.2712C2.10838 16.4179 2.40308 16.4968 2.70388 16.5H17.2961C17.5969 16.4968 17.8916 16.4179 18.1509 16.2712C18.4102 16.1244 18.625 15.9149 18.7739 15.6635C18.9229 15.4121 19.0008 15.1276 19 14.8383C18.9992 14.5489 18.9196 14.2648 18.7691 14.0142L11.473 2.29773C11.3194 2.05421 11.1032 1.85287 10.8452 1.71314C10.5872 1.57341 10.2961 1.5 10 1.5C9.7039 1.5 9.41281 1.57341 9.15479 1.71314C8.89678 1.85287 8.68056 2.05421 8.52699 2.29773Z",
    stroke: "#D9D9D9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayer9);
export default __webpack_public_path__ + "static/media/Layer9.afaa9426b6cb7e7de8a50ece141b5bdf.svg";
export { ForwardRef as ReactComponent };